import { Outlet } from "react-router-dom";

const Measurements = () => <Outlet />;

export default Measurements;
